import type { ComponentProps } from 'react';

import { cn } from '../cn';
import { type BadgeProps } from './Badge';

type BadgeIconProps = ComponentProps<'div'> &
  Pick<BadgeProps, 'type' | 'size'> & {
    icon: React.JSX.Element;
  };

export default function BadgeIcon({ type, size, icon, onClick, className, ...props }: BadgeIconProps) {
  return (
    <span
      className={cn(
        'flex size-6 shrink-0 items-center justify-center [&>*]:size-[58%]',
        {
          'w-4.5 h-4.5': size === 'sm',
          'h-3.5 w-3.5': size === 'xs',
        },
        { 'cursor-pointer': onClick },
        className,
        {
          'hover:bg-zumthor-300 dark:hover:bg-zumthor-400': type == null && onClick,
          'hover:bg-lynch-800': type === 'standard' && onClick,
          'hover:bg-mantis-600': type === 'success' && onClick,
          'hover:bg-fair-pink-300 dark:hover:bg-fair-pink-950': type === 'dangerous' && onClick,
          'hover:bg-quarter-spanish-white-400': (type === 'warning' || type === 'medium') && onClick,
          'hover:bg-quarter-spanish-white-800': type === 'high' && onClick,
          'hover:bg-quarter-spanish-white-200': type === 'low' && onClick,
        },
      )}
      onClick={onClick}
      {...props}>
      {icon}
    </span>
  );
}
